import { inject, Injectable } from '@angular/core';
import { RecentSearch, RecentSearches } from '@vueling-ng/vy-cdk-searcher';
import { Observable, of } from 'rxjs';
import { StationRecentSearchesConfiguration } from '../configurations/station-recent-searches.configuration';

@Injectable({
  providedIn: 'root'
})
export class RecentSearchesStorageService {
  private readonly storageKey = 'recentSearches';
  private readonly _config = inject(StationRecentSearchesConfiguration);

  public getRecentOriginSearches(): Observable<string[]> {
    const recentSearches = this.getFromStorage()?.origins || [];
    return of(recentSearches);
  }

  public getRecentDestinationsSearches(): Observable<string[]> {
    const recentSearches = this.getFromStorage()?.destinations || [];
    return of(recentSearches);
  }

  public clearRecentOrigins(): Observable<void> {
    const recentSearches = this.getFromStorage() || { origins: [], destinations: [] };
    recentSearches.origins = [];
    this.saveToStorage(recentSearches);
    return of();
  }

  public clearRecentDestinations(): Observable<void> {
    const recentSearches = this.getFromStorage() || { origins: [], destinations: [] };
    recentSearches.destinations = [];
    this.saveToStorage(recentSearches);
    return of();
  }

  public saveRecentSearch(search: RecentSearch): Observable<void> {
    const recentSearches = this.getFromStorage() || { origins: [], destinations: [] };
    recentSearches.origins = this.orderRecentSearches(recentSearches.origins, search.origin, this._config.maxOrigins);

    recentSearches.destinations = this.orderRecentSearches(
      recentSearches.destinations,
      search.destination,
      this._config.maxDestinations
    );
    this.saveToStorage(recentSearches);
    return of();
  }

  private orderRecentSearches(list: string[], station: string, maxItems: number): string[] {
    const filteredList = list.filter((s) => s !== station);

    return [station, ...filteredList].slice(0, maxItems);
  }

  private getFromStorage(): RecentSearches {
    const stored = localStorage.getItem(this.storageKey);
    if (stored) {
      try {
        return { origins: [], destinations: [], ...JSON.parse(stored) } as RecentSearches;
      } catch (e) {
        /* empty */
      }
    }
    return { origins: [], destinations: [] };
  }

  private saveToStorage(recentSearches: RecentSearches): void {
    localStorage.setItem(this.storageKey, JSON.stringify(recentSearches));
  }
}
